var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cardWrapperClass},[_c('div',{staticClass:"card__content"},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom-section")],2)}
var staticRenderFns = []

export { render, staticRenderFns }